import $ from 'jquery';

export const blackHeader = {
    header: document.querySelector('.header'),
    banner: document.querySelector('.home-intro'),
    body: document.querySelector('body'),

    scrollItem() {
        const {
            scrollY
        } = window;

        if (scrollY <= this.banner.scrollHeight - 74) {
            this.header.classList.add('color');
        } else {
            this.header.classList.remove('color');
        }
    },

    event() {
        window.addEventListener('scroll', () => {
            if (this.body.classList.contains('home')) {
                this.scrollItem();
            }
        })

        if (this.body.classList.contains('home')) {
            this.scrollItem();
        }
    },

    init() {
        this.event()
    }
}


// WEBPACK FOOTER //
// app/scripts/components/black-header.js